export function normalizePhoneDigits(phone) {
  if (!phone) {
    return null;
  }

  const digits = String(phone).replace(/\D/g, "");

  if (digits.length >= 10) {
    return digits.slice(-10);
  }

  return digits || null;
}

export function phoneForForm(phone) {
  if (!phone || !String(phone).trim()) {
    return "";
  }

  return String(phone).trim();
}

export function isValidPhoneInput(phone) {
  if (!phone || !String(phone).trim()) {
    return true;
  }

  const trimmed = String(phone).trim();

  if (/^\+[1-9]\d{1,14}$/.test(trimmed)) {
    return true;
  }

  return normalizePhoneDigits(trimmed)?.length === 10;
}

export const phoneValidationMessage =
  "Phone number must be E.164 (+12025550123) or a 10-digit US number";

export const phoneHelperText =
  "Use a 10-digit US number (2025550123) or E.164 (+12025550123).";
